import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { sell_requestApi } from "../../app/slices/sell_requestSlice";
import { Box, LinearProgress } from "@mui/material";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";

import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material";

import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";

export default function SellRequest() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    name: "",
    merchantTransactionId: "",
 
    customerRefNo: "",
  });

    const url = `/api/admin/augmont-sell-req/list`
  
    const { handleFilterSubmit, handleClearFilters, loader, results, apiCall,message,error,toastTrigger } = useFilterHandler(url, filterData, setFilterData)

  
  useEffect(() => {
     apiCall(false)
   }, []);
 
    useEffect(() => {
   if (!message) return;
 
   console.log("Message updated:", message);
 
   if (error) {
     toast.error(message);
   }
  //   else {
  //    // toast.success(message);
  //  }
 }, [toastTrigger]);
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  // useEffect(() => {
  //   dispatch(sell_requestApi(queryParams));
  // }, [dispatch, queryParams]);

  const sliceResponse = useSelector(
    (state) => state.sell_request.sell_request.data
  );
  const stateLoading = useSelector(
    (state) => state.sell_request.loading
  );


  const columnHelper = createMRTColumnHelper();

  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("customerName", {
      header: "Name",
      size: 30,
     
    }),
     columnHelper.accessor("phone", {
      header: "Phone",
      size: 30,
     
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
     
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      
    }),
     columnHelper.accessor("pricePerGram", {
      header: "Metal Rate",
      size: 30,
    
    }),
    //  columnHelper.accessor("metalRate", {
    //   header: "Metal Rate",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>{cell.row.original?.metalRate}</div>
    //   ),
    // }),
    //  columnHelper.accessor("preTaxAmount", {
    //   header: "Pre Tax Amount",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>{cell.row.original?.preTaxAmount}</div>
    //   ),
    // }),
    //  columnHelper.accessor("taxAmount", {
    //   header: "Tax Amount",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>{cell.row.original?.taxAmount}</div>
    //   ),
    // }),
    columnHelper.accessor("amount", {
      header: "Total Amount",
      size: 30,
     
    }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId
          );
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("blockId", {
      header: "Block ID",
      size: 30,
     
    }),
//  columnHelper.accessor("flag", {
//       header: "Flag ",
//       size: 30,
      
    
//     }),

   

     columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 30,
      
    
    }),

    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 30,
      
    
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 50,
      Cell: ({ cell }) => cell.row.original?.createdAt?.split("T")[0] || "N/A",
    }),
     columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 50,
      Cell: ({ cell }) => cell.row.original?.updatedAt?.split("T")[0] || "N/A",
    }),
  ];

  return (
    <>
     {/*  */}
       <Filter filterData={filterData} onFilterSubmit={handleFilterSubmit} Onclear={handleClearFilters} page={'augmont_sell_req'} setFilterData={setFilterData} />
            
      
      <>
        {" "}
        {/* <DateSearchComponent onSearch={handleSearch} /> */}
        <Box mt={2}>
         {loader?<Loader/>:<CustomTable columns={columns} data={results} loading={loader} permissionKey="SellRequests"/>} 
          
        </Box>
      </>

    </>
  );
}
